import React, { useContext, useEffect, useState } from "react";
import crownGolden from "../../images/crown_golden.png";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";
import { AppContext } from "../../contexts/AppContext";

export default function ProjectExpertIsVip({ isVip, expert_id }) {
  const { applications, setApplications } = useContext(AppContext);
  const [isVipPopup, setIsVipPopup] = useState(false);
  const [isVipGolden, setIsVipGolden] = useState("");
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    if (isVip === "yes") {
      setIsVipGolden("yes");
    } else {
      setIsVipGolden("no");
    }
  }, [isVip]);

  const handleIsVip = () => {
    const url = `${API_URL}save-prexpert-vip`;
    const data = {
      requestID: expert_id,
      isVip: isVipGolden === "yes" ? "no" : "yes",
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          if (isVipGolden === "yes") {
            setIsVipGolden("no");
          } else {
            setIsVipGolden("yes");
          }

          setApplications(
            applications.map((item) => {
              if (item.ID === expert_id) {
                item.isVip = isVipGolden === "yes" ? "no" : "yes";
              }
              return item;
            })
          );
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  return (
    <>
      {isVipGolden === "yes" ? (
        <button className="ua-goldenCrownBtn" onClick={() => handleIsVip()} />
      ) : (
        <button className="ua-silverCrownBtn" onClick={() => handleIsVip()} />
      )}
    </>
  );
}
